import { ColumnDef } from "@tanstack/react-table";
import { DetailedUserWithStats } from "@/user/user.d";

export const ReferralCodeCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Referral Code",
  accessorKey: "referral_code",
  cell: ({ getValue }) => {
    const referralCode = getValue() as number;
    return <>Referral{referralCode}</>;
  },
});
